export const prod_config = {
  apiKey: "AIzaSyBAWF0f0T8cJmGzdaP7zddo-ybJ_1bNo7I",
  authDomain: "samvidhan-75.firebaseapp.com",
  projectId: "samvidhan-75",
  storageBucket: "samvidhan-75.firebasestorage.app",
  messagingSenderId: "162168266824",
  appId: "1:162168266824:web:fb606a244b39d71055787d",
  measurementId: "G-KP8XZPHFJ1",
};
